"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { useUser } from "@/checkout/hooks/use-user";

/**
 * Keeps posthog-js distinct_id aligned with Saleor: canonical id is Saleor `User.id`.
 * Must render under AuthProvider (Urql + Saleor auth).
 */
export function PostHogIdentifySync() {
	const { user } = useUser();

	useEffect(() => {
		if (!user?.id) {
			return;
		}
		try {
			posthog.identify(user.id, {
				email: user.email ?? undefined,
			});
			try {
				posthog.reloadFeatureFlags();
			} catch {
				/* ignore */
			}
		} catch {
			/* posthog not initialized */
		}
	}, [user?.id, user?.email]);

	return null;
}
